<bn-loading-overlay></bn-loading-overlay>

<h5>Boletos de cobrança</h5>

<div class="container">
  <form [formGroup]="pesquisaForm" class="mt-3 mx-auto" (keyup.enter)="focusableSubmit.click()">
    <div class="mb-3 row">
      <div class="col">
        <h3>Filtros de pesquisa</h3>
      </div>
      <div class="col-auto" *ngIf="podeEscolherAgente">
        <button type="button" class="btn btn-primary" (click)="gerarRelatorioRepasseECG()">Relatório de Repasse de ECG</button>
      </div>
      <div class="col-auto">
        <button #focusableSubmit type="button" class="btn btn-success" (keydown.enter)="buscar(false, true)" (click)="buscar(false, true)">Pesquisar</button>
      </div>

    </div>

    <div class="row">

     <div class="bn-form-group col-md-6">
        <label class="form-label" for="agenteFinanceiro">Agente Financeiro:</label>
        <select *ngIf="podeEscolherAgente" id="agenteFinanceiro" class="form-select" [compareWith]="compararPorId" formControlName="agenteFinanceiro">
          <option [ngValue]="undefined" [selected]="!valoresPesquisaForm || !valoresPesquisaForm.agenteFinanceiro">Todos</option>
          <option *ngFor="let agente of agentesFinanceiros" [selected]="valoresPesquisaForm && valoresPesquisaForm.agenteFinanceiro == agente.nome">{{ agente.nome }}</option>
        </select>
        <select *ngIf="!podeEscolherAgente" disabled id="agenteFinanceiro" class="form-select" [compareWith]="compararPorId" formControlName="agenteFinanceiro">
        <ng-container *ngFor="let agente of agentesFinanceiros">
          <option selected *ngIf="agente.cnpj == cnpjUsuario">{{ agente.nome }}</option>
        </ng-container>
        </select>
      </div>
      <div class="bn-form-group col-md-3">
        <label class="form-label" for="tipo">Tipo de cobrança:</label>
        <select id="tipo" class="form-select" [compareWith]="compararPorId" formControlName="tipoCobranca">
          <option [ngValue]="undefined" [selected]="!valoresPesquisaForm || !valoresPesquisaForm.tipoCobranca">Todos</option>
           <option *ngFor="let tipoCobranca of tiposCobranca" [selected]="valoresPesquisaForm && valoresPesquisaForm.tipoCobranca == tipoCobranca.codigo">{{ tipoCobranca.labelCompleto }}</option>
        </select>
      </div>
      <div class="bn-form-group col-md-3">
        <label class="form-label" for="estado">Estado:</label>
        <select id="estado" class="form-select" [compareWith]="compararPorId" formControlName="estado">
          <option [ngValue]="undefined" [selected]="!valoresPesquisaForm || !valoresPesquisaForm.estado">Todos</option>
           <option *ngFor="let estado of estados" [selected]="valoresPesquisaForm && valoresPesquisaForm.estado == estado.nome">{{ estado.nome }}</option>
        </select>
      </div>

    </div>

    <div class="row">

      <div class="bn-form-group col-md-3">
        <label class="form-label" for="dataEmissaoDaFichaInicial">Data de emissão inicial:</label>
        <bn-datepicker name="dataEmissaoDaFichaInicial" idInput="dataEmissaoDaFichaInicial" formControlName="dataEmissaoDaFichaInicial" >
        </bn-datepicker>
      </div>

      <div class="bn-form-group col-md-3">
        <label class="form-label" for="dataEmissaoDaFichaFinal">Data de emissão final:</label>
        <bn-datepicker name="dataEmissaoDaFichaFinal" idInput="dataEmissaoDaFichaFinal" formControlName="dataEmissaoDaFichaFinal">
        </bn-datepicker>
      </div>

      <div class="bn-form-group col-md-3">
        <label class="form-label" for="dataVencimentoDaFichaInicial">Data de vencimento inicial:</label>
        <bn-datepicker name="dataVencimentoDaFichaInicial" idInput="dataVencimentoDaFichaInicial" formControlName="dataVencimentoDaFichaInicial" >
        </bn-datepicker>
      </div>

      <div class="bn-form-group col-md-3">
        <label class="form-label" for="dataVencimentoDaFichaFinal">Data de vencimento final:</label>
        <bn-datepicker name="dataVencimentoDaFichaFinal" idInput="dataVencimentoDaFichaFinal" formControlName="dataVencimentoDaFichaFinal">
        </bn-datepicker>
      </div>

      <div class="bn-form-group col-md-3">
        <label class="form-label" for="dataLimiteParaPagamentoDaFichaInicial">Data de pagamento inicial:</label>
        <bn-datepicker name="dataLimiteParaPagamentoDaFichaInicial" idInput="dataLimiteParaPagamentoDaFichaInicial" formControlName="dataLimiteParaPagamentoDaFichaInicial" >
        </bn-datepicker>
        </div>

        <div class="bn-form-group col-md-3">
        <label class="form-label" for="dataLimiteParaPagamentoDaFichaFinal">Data de pagamento final:</label>
        <bn-datepicker name="dataLimiteParaPagamentoDaFichaFinal" idInput="dataLimiteParaPagamentoDaFichaFinal" formControlName="dataLimiteParaPagamentoDaFichaFinal">
        </bn-datepicker>
        </div>

        <div class="bn-form-group col-md-2">
          <label class="form-label" for="idCobranca">ID da cobrança:</label>
          <input class="form-control" formControlName="idCobranca">
        </div>

        <div class="bn-form-group col-md-3">
        <label class="form-label" for="codigoCobranca">Código da cobrança:</label>
        <input class="form-control" formControlName="codigoCobranca">
        </div>

    </div>
  </form>
</div>

<app-cobranca-listagem
  [cobrancas]="cobrancas"
  [atributosPaginacao]="atributosPaginacaoComponenteListagem"
  [ehAgenteFinanceiro]="ehAgenteFinanceiro"
  *ngIf="pesquisado"
  [hidden]="esconderPesquisa"
  (aoMudarPagina)="mudancaPagina($event)">
</app-cobranca-listagem>